import { createSlice } from "@reduxjs/toolkit";
import { ICategoryAssignments } from "../interface/ICategoryAssignments";

const initialState: ICategoryAssignments[] | null = null;

const sessionAssignmentsSlice = createSlice({
  name: "sessionAssignments",
  initialState,
  reducers: {
    setSessionAssignmentsStore: (state: ICategoryAssignments[] | null, action: any | null) => {
      return action.payload;
    },
    setSessionAssignmentsNull: (state, action) => {
      return null;
    }
  },
});

export const { setSessionAssignmentsStore, setSessionAssignmentsNull } = sessionAssignmentsSlice.actions;

export default sessionAssignmentsSlice.reducer;
